import { FilesetResolver, FaceLandmarker } from '@mediapipe/tasks-vision';

let faceLandmarker;

export async function initFaceMesh() {
  const filesetResolver = await FilesetResolver.forVisionTasks(
    "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.11/wasm"
  );
  faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
    baseOptions: {
      modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
      delegate: "GPU"
    },
    runningMode: "IMAGE",
    outputFaceBlendshapes: true,
    numFaces: 1
  });
  return faceLandmarker;
}

export async function detectFaces(img) {
  try {
    if (!faceLandmarker) {
      const _faceLandmarker = await initFaceMesh();
    }
    let predictions; 
    try {
      predictions = await faceLandmarker.detect(img);
    } catch (err) {
      return predictions;
    }
    return predictions;
  } catch (error) {
    console.log("detectFaces error", error);
    return null
  }
  
}